import './page-title.scss'
import type { FC } from 'react'
import { memo } from 'react'

export interface PageTitleProps {
    text: string | undefined
    hide?: boolean
}

export const PageTitle: FC<PageTitleProps> = memo(props => {
    if (!props.text || props.hide) return null

    return <h1 className="page-title container-lg-padding">{props.text}</h1>
})
